import cx from 'classnames';
import React, { ReactNode, useRef } from 'react';

import SplitViewResizer from '../__resizer/split-view__resizer';
import { SimpleCallback } from '../../../typings';

// @ts-ignore
import styles from './split-view__pane.module.scss';

interface Props {
    onResizeStart: SimpleCallback;
    children: ReactNode;
    onResize: (movement: number) => void;
    onResizeEnd: (width: number) => void;
    resizable: boolean;
    size: number;
    minSize?: number;
    getSize: (el: HTMLElement) => number;
    direction: 'row' | 'column';
    className?: string;
    isResizing?: boolean;
    extendedResizerActiveArea: boolean;
}

const directionToMinSize = {
    row: 'minWidth',
    column: 'minHeight',
} as const;

const SplitViewPane = (props: Props) => {
    const ref = useRef<HTMLDivElement>(null);
    const className = cx(
        styles.pane,
        {
            [styles.pane_resizing]: props.isResizing,
        },
        'split-view__pane',
        props.className
    );

    return (
        <div
            className={className}
            ref={ref}
            style={{
                flexGrow: props.size,
                [directionToMinSize[props.direction]]: props.minSize && `${props.minSize}px`,
            }}
        >
            <div className={cx(styles.pane_content, 'split-view__pane-content')}>{props.children}</div>
            {props.resizable && (
                <SplitViewResizer
                    direction={props.direction}
                    extendedActiveArea={props.extendedResizerActiveArea}
                    onResize={props.onResize}
                    onResizeEnd={() => props.onResizeEnd(props.getSize(ref.current!))}
                    onResizeStart={() => props.onResizeStart()}
                />
            )}
        </div>
    );
};

export default React.memo(SplitViewPane);
